import './styles.js'
import $ from 'jquery'

import { customPreloader }  from './_customPreloader'
import { customAnimation }  from './_customAnimation'
import { customMenu }       from './_customMenu'
import { customSlider }     from './_customSlider'
import { customMask }       from './_customMask'
import { customAlert }      from './_customAlert'
import { customResize }     from './_customResize'

import fancybox from '@fancyapps/fancybox'

(function($) {

	$( window ).on('load', () => {

		$('[data-fancybox]').fancybox({
			image: true
		});

		customPreloader()
		customAnimation()
		customMenu()
		customSlider()
		customMask()
		customAlert()
	})
})(jQuery)

